import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '@services/loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  /**
   * Initilization
   */
  activeRequests = 0;

  /**
   * Constructor
   * @param loaderService
   */
  constructor(private readonly loaderService: LoaderService) {
    this.activeRequests = 0;
  }

  /*
   * Shows the global loading spinner for the duration of each HTTP request,
   * using a reference counter to correctly handle concurrent requests. The
   * spinner starts when the first request is in-flight and stops only when all
   * pending requests have completed or errored. Requests that carry the
   * 'isloaderDisable: true' header are passed through without touching the
   * counter, allowing individual calls to opt out of the global indicator.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      !request.headers.has('isloaderDisable') ||
      (request.headers.has('isloaderDisable') && request.headers.get('isloaderDisable') != 'true')
    ) {
      if (this.activeRequests === 0) this.loaderService.startLoading();

      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {
          if (this.activeRequests > 0) this.activeRequests--;
          if (this.activeRequests === 0) this.loaderService.stopLoading();
        }),
      );
    } else {
      return next.handle(request);
    }
  }
}
